import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";

const url = 'https://computer-quiz-backend.herokuapp.com/user';

export const useGetUser = () => {
  const [user, setUser] = useState();
  const [error, setError] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await axios.get(url, {
          headers: { 'api-token': localStorage.getItem('token') }
        });
        setUser(data);
      } catch (error) {
        setError(error.message);
        history.push('/');
      }
    };

    fetchUser();
  }, [history]);

  return { user, error };
};